import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helpers } from '@smiles/voebiz-core-engine';
import HeaderIcon from '../Icons/HeaderIcon';

const Header = () => {
  const { t } = useTranslation('beneficiaries');

  const labelTitle = t('title');

  const enableRewardCustomers = Helpers?.getConstants('ENABLE_VOEBIZ_REWARD_CUSTOMERS');

  const rewardCustomersIsEnabled = typeof enableRewardCustomers === 'boolean' && enableRewardCustomers;

  const labelSubTitle = rewardCustomersIsEnabled ? t('subtitle_reward') : t('subtitle');

  return (
    <>
      <div className="w-100 main-page-container">
        <div className="w-100 container-header">
          <div className="header-main-page">
            <h1 className="title-main-page mb-0">{labelTitle}</h1>
            <h3 className="subtitle-main-page" data-testid="subtitle-main-page">
              {labelSubTitle}
            </h3>
          </div>
          <div className="img-container">
            <HeaderIcon />
          </div>
        </div>
        <div className="container-header-mobile">
          <div className="img-container">
            <div className="title-wrapper">
              <span className="title">{labelTitle}</span>
              <span className="subtitle">{labelSubTitle}</span>
            </div>
            <div className="mobile-img">
              <HeaderIcon />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
